import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { LogService } from "../../services/logging/log-service";
import { AuthenticationService } from "../../services/authentication.service";

@Injectable({
  providedIn: 'root'
})
export class VirtualFileService {
    
    constructor(
        private http: HttpClient,
        private logService: LogService,
        private authenticationService: AuthenticationService,
    ) {}

}